import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Table from '@material-ui/core/Table';
import ChargeEventTableHead from '../../components/molecules/ChargeEventTableHead';
import ChargeEventTableBody from '../../components/molecules/ChargeEventTableBody';
import GroupIdentityRegister from './GroupIdentityRegister';
import GroupIdentityApproval from './GroupIdentityApproval';
import ExPagination from '../../components/molecules/ExPagination';
import { getStripeChargeEvents } from '../../actions/ChargeEvent';
import { sendLogin } from '../../auth/Auth';
import {
  resendMailGochiData,
  resendGochiData,
  rejectGochiData
} from '../../libs/apis/GochiApi';

const styles = {
  scrollTable: {
    maxHeight: '60vh',
    overflowX: 'scroll',
    whiteSpace: 'nowrap'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      name: state.loginInfo.name,
      stripeChargeEvents: state.stripeChargeEvents.billErrorDtoList,
      totalCount: state.stripeChargeEvents.totalItems
    }),
    dispatch => ({
      actions: bindActionCreators({ getStripeChargeEvents }, dispatch)
    })
  ),
  setPropTypes(propTypes),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('openRegisterModal', 'updateOpenRegisterModal', false),
  withState('openApprovalModal', 'updateOpenApprovalModal', false),
  withState(
    'openApprovalConfirmModal',
    'updateOpenApprovalConfirmModal',
    false
  ),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withState('identityId', 'setIdentityId', null),
  withState('shopId', 'setShopId', null),
  withState('sealCertificate', 'setSealCertificate', null),
  withState('businessLicense', 'setBusinessLicense', null),
  withState('other', 'setOther', null),
  withState('note', 'setNote', null),
  withState('targetRowId', 'setTargetRowId', 0),
  withState('page', 'setPage', 0),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleChangeRowsPerPage: props => (event, rowsPerPage) => {
      props.setRowsPerPage(rowsPerPage);
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    roles,
    progress,
    stripeChargeEvents,
    searchKey,
    page,
    selectedPage,
    totalCount,
    handleChangePage,
    openRegisterModal,
    updateOpenRegisterModal,
    openApprovalModal,
    updateOpenApprovalModal,
    openApprovalConfirmModal,
    updateOpenApprovalConfirmModal,
    rowsPerPage,
    handleChangeRowsPerPage,
    identityId,
    setIdentityId,
    shopId,
    setShopId,
    sealCertificate,
    setSealCertificate,
    businessLicense,
    setBusinessLicense,
    other,
    setOther,
    note,
    setNote,
    targetRowId,
    setTargetRowId
  }) => {
    const detail = {
      identityId,
      shopId,
      sealCertificate,
      businessLicense,
      other,
      note
    };

    const registerOpenAction = params => {
      updateOpenRegisterModal(true);
      setTargetRowId(params.id);
    };
    const confirmOpenAction = async params => {
      setIdentityId(params.identityId);
      setShopId(params.shopId);
      setSealCertificate(params.sealCertificate);
      setBusinessLicense(params.businessLicense);
      setOther(params.other);
      setNote(params.note);
      updateOpenApprovalModal(true);
    };

    const resendMailAction = params => {
      progress.updateOpenProgress(true);
      progress.updateLoading(true);
      resendMailGochiData({
        id: params.id,
        merchantPaymentId: params.merchantPaymentId
      })
        .then(async data => {
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
          if (data.status === 200) {
            alert('成功しました。');
            handleChangePage(null, 1, rowsPerPage.textContent);
          } else {
            alert('失敗しました');
          }
        })
        .catch(() => {
          alert('失敗しました');
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
        });
    };

    const resendGochiAction = params => {
      progress.updateOpenProgress(true);
      progress.updateLoading(true);
      resendGochiData({
        id: params.id,
        merchantPaymentId: params.merchantPaymentId
      })
        .then(async data => {
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
          if (data.status === 200) {
            alert('成功しました。');
            handleChangePage(null, 1, rowsPerPage.textContent);
          } else {
            alert('失敗しました');
          }
        })
        .catch(() => {
          alert('失敗しました');
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
        });
    };

    const rejectGochiAction = params => {
      progress.updateOpenProgress(true);
      progress.updateLoading(true);
      rejectGochiData({ id: params.id })
        .then(async data => {
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
          if (data.status === 200) {
            alert('成功しました。');
            handleChangePage(null, 1, rowsPerPage.textContent);
          } else {
            alert('失敗しました');
          }
        })
        .catch(() => {
          alert('失敗しました');
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
        });
    };

    return (
      <div>
        <div className={classes.scrollTable} id="scrollTableId">
          <Table stickyHeader>
            <ChargeEventTableHead roles={roles} />
            <ChargeEventTableBody
              stripeChargeEvents={stripeChargeEvents}
              page={page}
              rowsPerPage={rowsPerPage}
              registerOpenAction={registerOpenAction}
              confirmOpenAction={confirmOpenAction}
              updateOpenRegisterModal={updateOpenRegisterModal}
              updateOpenConfirmModal={updateOpenApprovalModal}
              setTargetRowId={setTargetRowId}
              roles={roles}
              resendMailAction={resendMailAction}
              resendGochiAction={resendGochiAction}
              rejectGochiAction={rejectGochiAction}
            />
          </Table>
        </div>
        {(roles.isGroup || roles.isSecretariat || roles.isDeveloper) && (
          <div>
            <ExPagination
              searchResults={stripeChargeEvents}
              rowsPerPage={rowsPerPage}
              page={page}
              handleChangePage={handleChangePage}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
              totalCount={totalCount}
              offset={page * rowsPerPage}
              selectedPage={selectedPage}
            />
          </div>
        )}
        <Modal open={openRegisterModal}>
          <GroupIdentityRegister
            updateOpenRegisterModal={updateOpenRegisterModal}
            searchKey={searchKey}
            targetRowId={targetRowId}
          />
        </Modal>
        <Modal open={openApprovalModal}>
          <GroupIdentityApproval
            updateOpenApprovalModal={updateOpenApprovalModal}
            openApprovalConfirmModal={openApprovalConfirmModal}
            updateOpenApprovalConfirmModal={updateOpenApprovalConfirmModal}
            detail={detail}
            targetRowId={targetRowId}
            searchKey={searchKey}
          />
        </Modal>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
